import React, { forwardRef } from 'react'
import * as UIcons from '@iconscout/react-unicons'
import ClickAwayComponent from 'components/ClickAwayComponent'

const STATUS_TONES = {
  Active: 'text-success',
  Upcoming: 'text-orange-500',
  Completed: 'text-secondary'
}

export default function TransactionCampaignPill({ campaigns, active, onSelect }) {
  return (
    <ClickAwayComponent
      Component={forwardRef(({ handleClick, open }, ref) => (
        <div className="relative" ref={ref}>
          <button
            type="button"
            onClick={handleClick}
            className="flex items-center gap-2 bg-background rounded-full h-9 px-3.5 text-sm whitespace-nowrap"
          >
            <span className="w-3 h-3 rounded-full bg-success shrink-0" />
            <span className="text-secondary">Active Campaign:</span>
            <span className="font-semibold text-dark-blue">{active?.title ?? '—'}</span>
            {open ? <UIcons.UilAngleUp size={16} className="text-secondary" /> : <UIcons.UilAngleDown size={16} className="text-secondary" />}
          </button>

          {
            open && (
              <div className="absolute right-0 top-11 z-20 w-[420px] bg-white border border-border-lines rounded-xl shadow-lg py-1">
                {
                  campaigns.map((campaign) => (
                    <button
                      key={campaign.id}
                      type="button"
                      onClick={() => { onSelect(campaign); handleClick() }}
                      className="w-full flex items-center gap-3 text-left px-4 py-3 hover:bg-background"
                    >
                      <span className="w-[55px] h-12 rounded-lg bg-primary shrink-0" />
                      <span className="min-w-0 flex-1">
                        <span className="block text-sm text-dark-blue truncate">{campaign.title}</span>
                        <span className="flex items-center gap-1 text-xs text-secondary">
                          {campaign.type}
                          <span aria-hidden>•</span>
                          <span className={STATUS_TONES[campaign.status] || 'text-secondary'}>{campaign.status}</span>
                        </span>
                      </span>
                      {campaign.id === active?.id && <UIcons.UilCheck size={18} className="text-primary shrink-0" />}
                    </button>
                  ))
                }
              </div>
            )
          }
        </div>
      ))}
    />
  )
}
